module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.559e978f.woff2";